import React from 'react';

import {useI18n} from '@udemy/i18n';
import {AlertBanner} from '@udemy/react-messaging-components';

import {useGetInstructorAccountIssuesQuery} from '../../generated/graphql';
import styles from './section.module.less';

export const WarningSection = () => {
    const instructorAccountIssues = useGetInstructorAccountIssuesQuery();
    const {gettext} = useI18n();

    const getWarningNoTaxForms = () => {
        if (instructorAccountIssues.data?.instructorAccountIssues?.noTaxForms) {
            return (
                <AlertBanner
                    body={gettext(
                        'Your payouts are currently paused due to missing tax information. Please provide your tax details to continue receiving payouts.',
                    )}
                    dismissButtonProps={false}
                    title={gettext('We need your withholding tax information')}
                    udStyle="error"
                    ctaText={gettext('Submit tax documentation')}
                    onAction={() => {
                        window.open('/instructor/user/edit-instructor-info/');
                    }}
                />
            );
        } else return null;
    };
    const getWarningNoPayoutMethod = () => {
        if (instructorAccountIssues.data?.instructorAccountIssues?.noPayoutMethod) {
            return (
                <AlertBanner
                    body={gettext(
                        'Your payouts are currently paused due to missing payout method information. Please provide your payout method details to continue receiving payouts.',
                    )}
                    dismissButtonProps={false}
                    title={gettext('We need your payout method')}
                    udStyle="error"
                    ctaText={gettext('Update payout method')}
                    onAction={() => {
                        window.open('/instructor/user/edit-instructor-info/');
                    }}
                />
            );
        } else return null;
    };
    const getWarningNoAbn = () => {
        if (instructorAccountIssues.data?.instructorAccountIssues?.noAbn) {
            return (
                <AlertBanner
                    body={gettext(
                        'Our records indicate you do not currently have a valid ABN. The payout of your Udemy earnings will be suspended until a valid ABN is submitted.',
                    )}
                    dismissButtonProps={false}
                    title={gettext('We need your Australian Business Number (ABN).')}
                    udStyle="error"
                    ctaText={gettext('Click to submit your ABN')}
                    onAction={() => {
                        window.open('/instructor/user/edit-instructor-info/');
                    }}
                />
            );
        } else return null;
    };

    return getWarningNoTaxForms() != null ||
        getWarningNoPayoutMethod() != null ||
        getWarningNoAbn() != null ? (
        <div className={styles['section-container']}>
            {getWarningNoTaxForms()}
            {getWarningNoPayoutMethod()}
            {getWarningNoAbn()}
        </div>
    ) : null;
};
